<template>
  <div>
    <div class="c-nav-dropdown__content">
      <sc-text
        v-if="fields && fields.heading"
        :field="fields.heading"
        class="c-nav-dropdown__headline"
      />
      <sc-text
        v-if="fields && fields.content"
        :field="fields.content"
        class="c-nav-dropdown__text"
      />
    </div>
    <div class="c-nav-dropdown__divider"></div>
    <div class="c-nav-dropdown__links">
      <div class="c-link-list">
        <sc-placeholder name="jss-link" :rendering="rendering" />
      </div>
      <div class="c-link-list">
        <sc-placeholder name="jss-link-second" :rendering="rendering" />
      </div>
      <div class="c-link-list-bottom">
        <sc-placeholder name="jss-link-bottom" :rendering="rendering" />
      </div>
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-ContentWithLinks',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  }
};
</script>
